import React, { useState, useEffect, useCallback } from 'react';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import { Grid, GridItem } from '../../../components/Grid';
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  TextInput,
  MessageBox,
  Button,
  ResetButton,
  Legend,
} from '../../../components/FormElements';
import API from '../../../api';
import { API_RESPONSE_TYPES } from '../../../constants';

const AppTheme = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');
  const [appName, setAppName] = useState('');
  const [appLogo, setAppLogo] = useState('');
  const [appFavicon, setAppFavicon] = useState('');
  const [homeBanner, setHomeBanner] = useState('');
  const [appPhoneNumber, setAppPhoneNumber] = useState('');
  const [appEmailAddress, setAppEmailAddress] = useState('');
  const [firmName, setFirmName] = useState('');
  const [gstNumber, setGstNumber] = useState('');
  const [firmAddress, setFirmAddress] = useState('');
  const [invoicePrefix, setInvoicePrefix] = useState('');
  const [hsnCode, setHsnCode] = useState('');
  const [invoiceDescription, setInvoiceDescription] = useState('');
  const [appBackgroundColor, setAppBackgroundColor] = useState('');
  const [appPrimaryColor, setAppPrimaryColor] = useState('');
  const [appSecondaryColor, setAppSecondaryColor] = useState('');
  const [appTertiaryColor, setAppTertiaryColor] = useState('');
  const [appTableHeaderColor, setAppTableHeaderColor] = useState('');
  const [masterDistributorsCommission, setMasterDistributorsCommission] =
    useState('');
  const [distributorsCommission, setDistributorsCommission] = useState('');
  const [retailersCommission, setRetailersCommission] = useState('');
  const [apiUsersCommission, setApiUsersCommission] = useState('');
  const [upiMinimumAmount, setUpiMinimumAmount] = useState(0);
  const [privacyPolicy, setPrivacyPolicy] = useState('');
  const [termsAndConditions, setTermsAndConditions] = useState('');
  const [aboutUs, setAboutUs] = useState('');
  const [originalFormData, setOriginalFormData] = useState({});
  const [appAuthLogoBackgroundColor, setAppAuthLogoBackgroundColor] =
    useState('');
  const [appAuthPrimaryBackgroundColor, setAppAuthPrimaryBackgroundColor] =
    useState('');
  const [appAuthTextColor, setAppAuthTextColor] = useState('');
  const [appAuthPrimaryButtonColor, setAppAuthPrimaryButtonColor] =
    useState('');
  const [appAuthPrimaryButtonTextColor, setAppAuthPrimaryButtonTextColor] =
    useState('');
  const [appAuthSecondaryButtonColor, setAppAuthSecondaryButtonColor] =
    useState('');
  const [appAuthSecondaryButtonTextColor, setAppAuthSecondaryButtonTextColor] =
    useState('');
  const [appAuthOTPBackgroundColor, setAppAuthOTPBackgroundColor] =
    useState('');
  const [appMprimaryColor, setAppMprimaryColor] = useState('');
  const [appMsecondaryColor, setAppMsecondaryColor] = useState('');
  const [appMtertiaryColor, setAppMtertiaryColor] = useState('');
  const [appTextColor, setAppTextColor] = useState('');
  const [appIconColor, setAppIconColor] = useState('');
  const [appIconBackgroundColor, setAppIconBackgroundColor] = useState('');
  const [appButtonBackgroundColor, setAppButtonBackgroundColor] = useState('');
  const [appButtonTextColor, setAppButtonTextColor] = useState('');
  const [landingPrimaryColor, setLandingPrimaryColor] = useState('');
  const [landingSecondaryColor, setLandingSecondaryColor] = useState('');
  const [landingTertiaryColor, setLandingTertiaryColor] = useState('');

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus('');
    setResponseMessage('');
  };

  const resetForm = () => {
    const {
      appName,
      appLogo,
      appFavicon,
      homeBanner,
      appPhoneNumber,
      appEmailAddress,
      appBackgroundColor,
      appPrimaryColor,
      appSecondaryColor,
      appTertiaryColor,
      appTableHeaderColor,
      firmName,
      gstNumber,
      firmAddress,
      invoicePrefix,
      hsnCode,
      invoiceDescription,
      masterDistributorsCommission,
      distributorsCommission,
      retailersCommission,
      apiUsersCommission,
      upiMinimumAmount,
      privacyPolicy,
      termsAndConditions,
      aboutUs,
      appAuthLogoBackgroundColor,
      appAuthPrimaryBackgroundColor,
      appAuthTextColor,
      appAuthPrimaryButtonColor,
      appAuthPrimaryButtonTextColor,
      appAuthSecondaryButtonColor,
      appAuthSecondaryButtonTextColor,
      appAuthOTPBackgroundColor,
      appMprimaryColor,
      appMsecondaryColor,
      appMtertiaryColor,
      appTextColor,
      appIconColor,
      appIconBackgroundColor,
      appButtonBackgroundColor,
      appButtonTextColor,
      landingPrimaryColor,
      landingSecondaryColor,
      landingTertiaryColor,
    } = originalFormData;
    setAppName(appName);
    setAppLogo(appLogo);
    setAppFavicon(appFavicon);
    setHomeBanner(homeBanner);
    setAppPhoneNumber(appPhoneNumber);
    setAppEmailAddress(appEmailAddress);
    setAppBackgroundColor(appBackgroundColor);
    setAppPrimaryColor(appPrimaryColor);
    setAppSecondaryColor(appSecondaryColor);
    setAppTertiaryColor(appTertiaryColor);
    setAppTableHeaderColor(appTableHeaderColor);
    setFirmName(firmName);
    setGstNumber(gstNumber);
    setFirmAddress(firmAddress);
    setInvoicePrefix(invoicePrefix);
    setHsnCode(hsnCode);
    setInvoiceDescription(invoiceDescription);
    setMasterDistributorsCommission(masterDistributorsCommission);
    setDistributorsCommission(distributorsCommission);
    setRetailersCommission(retailersCommission);
    setApiUsersCommission(apiUsersCommission);
    setUpiMinimumAmount(upiMinimumAmount);
    setPrivacyPolicy(privacyPolicy);
    setTermsAndConditions(termsAndConditions);
    setAboutUs(aboutUs);
    setAppAuthLogoBackgroundColor(appAuthLogoBackgroundColor);
    setAppAuthPrimaryBackgroundColor(appAuthPrimaryBackgroundColor);
    setAppAuthTextColor(appAuthTextColor);
    setAppAuthPrimaryButtonColor(appAuthPrimaryButtonColor);
    setAppAuthPrimaryButtonTextColor(appAuthPrimaryButtonTextColor);
    setAppAuthSecondaryButtonColor(appAuthSecondaryButtonColor);
    setAppAuthSecondaryButtonTextColor(appAuthSecondaryButtonTextColor);
    setAppAuthOTPBackgroundColor(appAuthOTPBackgroundColor);
    setAppMprimaryColor(appMprimaryColor);
    setAppMsecondaryColor(appMsecondaryColor);
    setAppMtertiaryColor(appMtertiaryColor);
    setAppTextColor(appTextColor);
    setAppIconColor(appIconColor);
    setAppIconBackgroundColor(appIconBackgroundColor);
    setAppButtonBackgroundColor(appButtonBackgroundColor);
    setAppButtonTextColor(appButtonTextColor);
    setLandingPrimaryColor(landingPrimaryColor);
    setLandingSecondaryColor(landingSecondaryColor);
    setLandingTertiaryColor(landingTertiaryColor);
  };

  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(`/configurations/meta-details`)
      .then(({ data }) => {
        const {
          appName,
          appLogo,
          appFavicon,
          homeBanner,
          appPhoneNumber,
          appEmailAddress,
          appBackgroundColor,
          appPrimaryColor,
          appSecondaryColor,
          appTertiaryColor,
          appTableHeaderColor,
          firmName,
          gstNumber,
          firmAddress,
          invoicePrefix,
          hsnCode,
          invoiceDescription,
          masterDistributorsCommission,
          distributorsCommission,
          retailersCommission,
          apiUsersCommission,
          upiMinimumAmount,
          privacyPolicy,
          termsAndConditions,
          aboutUs,
          appAuthLogoBackgroundColor,
          appAuthPrimaryBackgroundColor,
          appAuthTextColor,
          appAuthPrimaryButtonColor,
          appAuthPrimaryButtonTextColor,
          appAuthSecondaryButtonColor,
          appAuthSecondaryButtonTextColor,
          appAuthOTPBackgroundColor,
          appMprimaryColor,
          appMsecondaryColor,
          appMtertiaryColor,
          appTextColor,
          appIconColor,
          appIconBackgroundColor,
          appButtonBackgroundColor,
          appButtonTextColor,
          landingPrimaryColor,
          landingSecondaryColor,
          landingTertiaryColor,
        } = data;
        setAppName(appName);
        setAppLogo(appLogo);
        setAppFavicon(appFavicon);
        setHomeBanner(homeBanner);
        setAppPhoneNumber(appPhoneNumber);
        setAppEmailAddress(appEmailAddress);
        setAppBackgroundColor(appBackgroundColor);
        setAppPrimaryColor(appPrimaryColor);
        setAppSecondaryColor(appSecondaryColor);
        setAppTertiaryColor(appTertiaryColor);
        setAppTableHeaderColor(appTableHeaderColor);
        setFirmName(firmName);
        setGstNumber(gstNumber);
        setFirmAddress(firmAddress);
        setInvoicePrefix(invoicePrefix);
        setHsnCode(hsnCode);
        setInvoiceDescription(invoiceDescription);
        setMasterDistributorsCommission(masterDistributorsCommission);
        setDistributorsCommission(distributorsCommission);
        setRetailersCommission(retailersCommission);
        setApiUsersCommission(apiUsersCommission);
        setUpiMinimumAmount(upiMinimumAmount);
        setPrivacyPolicy(privacyPolicy);
        setTermsAndConditions(termsAndConditions);
        setAboutUs(aboutUs);
        setAppAuthLogoBackgroundColor(appAuthLogoBackgroundColor);
        setAppAuthPrimaryBackgroundColor(appAuthPrimaryBackgroundColor);
        setAppAuthTextColor(appAuthTextColor);
        setAppAuthPrimaryButtonColor(appAuthPrimaryButtonColor);
        setAppAuthPrimaryButtonTextColor(appAuthPrimaryButtonTextColor);
        setAppAuthSecondaryButtonColor(appAuthSecondaryButtonColor);
        setAppAuthSecondaryButtonTextColor(appAuthSecondaryButtonTextColor);
        setAppAuthOTPBackgroundColor(appAuthOTPBackgroundColor);
        setAppMprimaryColor(appMprimaryColor);
        setAppMsecondaryColor(appMsecondaryColor);
        setAppMtertiaryColor(appMtertiaryColor);
        setAppTextColor(appTextColor);
        setAppIconColor(appIconColor);
        setAppIconBackgroundColor(appIconBackgroundColor);
        setAppButtonBackgroundColor(appButtonBackgroundColor);
        setAppButtonTextColor(appButtonTextColor);
        setLandingPrimaryColor(landingPrimaryColor);
        setLandingSecondaryColor(landingSecondaryColor);
        setLandingTertiaryColor(landingTertiaryColor);
        setOriginalFormData({
          appName,
          appLogo,
          appFavicon,
          homeBanner,
          appPhoneNumber,
          appEmailAddress,
          appBackgroundColor,
          appPrimaryColor,
          appSecondaryColor,
          appTertiaryColor,
          appTableHeaderColor,
          firmName,
          gstNumber,
          firmAddress,
          invoicePrefix,
          hsnCode,
          invoiceDescription,
          masterDistributorsCommission,
          distributorsCommission,
          retailersCommission,
          apiUsersCommission,
          upiMinimumAmount,
          privacyPolicy,
          termsAndConditions,
          aboutUs,
          appAuthLogoBackgroundColor,
          appAuthPrimaryBackgroundColor,
          appAuthTextColor,
          appAuthPrimaryButtonColor,
          appAuthPrimaryButtonTextColor,
          appAuthSecondaryButtonColor,
          appAuthSecondaryButtonTextColor,
          appAuthOTPBackgroundColor,
          appMprimaryColor,
          appMsecondaryColor,
          appMtertiaryColor,
          appTextColor,
          appIconColor,
          appIconBackgroundColor,
          appButtonBackgroundColor,
          appButtonTextColor,
          landingPrimaryColor,
          landingSecondaryColor,
          landingTertiaryColor,
        });
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    const formData = {
      appName,
      appLogo,
      appFavicon,
      homeBanner,
      appPhoneNumber,
      appEmailAddress,
      firmName,
      gstNumber,
      firmAddress,
      invoicePrefix,
      hsnCode,
      invoiceDescription,
      appBackgroundColor,
      appPrimaryColor,
      appSecondaryColor,
      appTertiaryColor,
      appTableHeaderColor,
      masterDistributorsCommission,
      distributorsCommission,
      retailersCommission,
      apiUsersCommission,
      upiMinimumAmount,
      privacyPolicy,
      termsAndConditions,
      aboutUs,
      appAuthLogoBackgroundColor,
      appAuthPrimaryBackgroundColor,
      appAuthTextColor,
      appAuthPrimaryButtonColor,
      appAuthPrimaryButtonTextColor,
      appAuthSecondaryButtonColor,
      appAuthSecondaryButtonTextColor,
      appAuthOTPBackgroundColor,
      appMprimaryColor,
      appMsecondaryColor,
      appMtertiaryColor,
      appTextColor,
      appIconColor,
      appIconBackgroundColor,
      appButtonBackgroundColor,
      appButtonTextColor,
      landingPrimaryColor,
      landingSecondaryColor,
      landingTertiaryColor,
    };
    API.put(`/configurations/meta-details`, formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setTimeout(() => {
            resetResponseData();
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    readData();
  }, [readData]);

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          <Fieldset forLegend>
            <Legend>Landing Page Colours</Legend>
            <Grid
              columns={
                'calc(33.33% - 13.33px) calc(33.33% - 13.33px) calc(33.33% - 13.33px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>Primary Color</Label>
                  <TextInput
                    type="color"
                    value={landingPrimaryColor}
                    onChange={setLandingPrimaryColor}
                    placeholder="Please select primary color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Secondary Color</Label>
                  <TextInput
                    type="color"
                    value={landingSecondaryColor}
                    onChange={setLandingSecondaryColor}
                    placeholder="Please select secondary color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Tertiary Color</Label>
                  <TextInput
                    type="color"
                    value={landingTertiaryColor}
                    onChange={setLandingTertiaryColor}
                    placeholder="Please select tertiary color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend>
            <Legend>Web Application Colours</Legend>
            <Fieldset>
              <Label>Background Color</Label>
              <TextInput
                type="color"
                value={appBackgroundColor}
                onChange={setAppBackgroundColor}
                placeholder="Please select background color"
                disabled={isLoading === true}
                style={{ padding: '0px', height: '48px', width: '100%' }}
              />
            </Fieldset>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>Primary Color</Label>
                  <TextInput
                    type="color"
                    value={appPrimaryColor}
                    onChange={setAppPrimaryColor}
                    placeholder="Please select primary color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Secondary Color</Label>
                  <TextInput
                    type="color"
                    value={appSecondaryColor}
                    onChange={setAppSecondaryColor}
                    placeholder="Please select secondary color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Tertiary Color</Label>
                  <TextInput
                    type="color"
                    value={appTertiaryColor}
                    onChange={setAppTertiaryColor}
                    placeholder="Please select tertiary color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Table Header Color</Label>
                  <TextInput
                    type="color"
                    value={appTableHeaderColor}
                    onChange={setAppTableHeaderColor}
                    placeholder="Please select table header color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend>
            <Legend>Mobile Application Colours</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>APP Auth Logo Background Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthLogoBackgroundColor}
                    onChange={setAppAuthLogoBackgroundColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Auth Primary Background Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthPrimaryBackgroundColor}
                    onChange={setAppAuthPrimaryBackgroundColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Auth Text Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthTextColor}
                    onChange={setAppAuthTextColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Auth OTP Background Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthOTPBackgroundColor}
                    onChange={setAppAuthOTPBackgroundColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>APP Auth Primary Button Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthPrimaryButtonColor}
                    onChange={setAppAuthPrimaryButtonColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Auth Primary Button Text Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthPrimaryButtonTextColor}
                    onChange={setAppAuthPrimaryButtonTextColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Auth Secondary Button Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthSecondaryButtonColor}
                    onChange={setAppAuthSecondaryButtonColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Auth Secondary Button Text Color</Label>
                  <TextInput
                    type="color"
                    value={appAuthSecondaryButtonTextColor}
                    onChange={setAppAuthSecondaryButtonTextColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>APP Primary Color</Label>
                  <TextInput
                    type="color"
                    value={appMprimaryColor}
                    onChange={setAppMprimaryColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Secondary Color</Label>
                  <TextInput
                    type="color"
                    value={appMsecondaryColor}
                    onChange={setAppMsecondaryColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Tertiary Color</Label>
                  <TextInput
                    type="color"
                    value={appMtertiaryColor}
                    onChange={setAppMtertiaryColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Text Color</Label>
                  <TextInput
                    type="color"
                    value={appTextColor}
                    onChange={setAppTextColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>APP Icon Color</Label>
                  <TextInput
                    type="color"
                    value={appIconColor}
                    onChange={setAppIconColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Icon Background Color</Label>
                  <TextInput
                    type="color"
                    value={appIconBackgroundColor}
                    onChange={setAppIconBackgroundColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Button Color</Label>
                  <TextInput
                    type="color"
                    value={appButtonBackgroundColor}
                    onChange={setAppButtonBackgroundColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>APP Button Text Color</Label>
                  <TextInput
                    type="color"
                    value={appButtonTextColor}
                    onChange={setAppButtonTextColor}
                    placeholder="Please select color"
                    disabled={isLoading === true}
                    style={{ padding: '0px', height: '48px', width: '100%' }}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <Button disabled={isLoading === true} type="submit">
              Update
            </Button>
            <ResetButton
              disabled={isLoading === true}
              type="button"
              onClick={resetForm}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(AppTheme);
